import React, { useState, useEffect, useContext } from "react";
import {
  TextField,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Tab,
  Tabs
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import context from "context/context";
import { useTranslation } from "react-i18next";
import Loader from "components/Loader/Loader";
import Table from "components/Table/Table";
import AutoEmailTemplates from "apis/AutoEmailTemplate/AutoEmailTemplate";
import { styles } from "./styles";
import { toast } from "react-toastify";

export default function AutoEmailTemplate() {
  const classes = styles();
  const { state, dispatch } = useContext(context);
  const { t } = useTranslation();
  const { gettemplate, handleSendEmail ,updateSubject} = AutoEmailTemplates();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const limit = 10;
  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [res, setRes] = useState(false);
  const [sendModalOpen, setSendModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedRecipientEmail, setSelectedRecipientEmail] = useState("");
  const [selectedLoyaltyId, setSelectedLoyaltyId] = useState("");
  const [billToId, setBillToId] = useState("");
  const [idType, setIdType] = useState("loyalty");
  const [editSubject,setEditSubject]=useState("");
  const [tabValue,setTabValue]=useState(0);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [transactionNumber, setTransactionNumber] = useState('');
  const [pointsRedeemed, setPointsRedeemed] = useState('');
  const [creditPoints, setCreditPoints] = useState('');

  const templatesWithoutIDs = [
    "forgotPassword",
    "uSFailedNotification",
    "createNewAdmin",
    "passwordExpirationNotification",
    "cAFailedNotification",
  ];

  useEffect(() => {
    fetchTemplates();
  }, [offset]);

  const fetchTemplates = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      const payload = {
        offset: (offset - 1) * limit,
        limit,
        query: searchValue.trim() || "",
      };
      const response = await gettemplate(payload);
      if (response) {
        setData(response.data || []);
        setCount(response.count || 0);
        setRes(true);
      }
    } catch (error) {
      console.error("Failed to fetch templates", error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handlePagination = (page) => setOffset(page);

  const handleSendClick = async () => {
    try {
      const skipIDs = templatesWithoutIDs.includes(selectedTemplate?.template);

      if (
        !selectedRecipientEmail ||
        !selectedTemplate?.template ||
        (!skipIDs &&
          ((idType === "loyalty" && !selectedLoyaltyId) ||
            (idType === "billto" && !billToId)))
      ) {
        toast.error("Please provide all required fields");
        return;
      }

      const payload = {
        to: selectedRecipientEmail.trim(),
        template: selectedTemplate.template,
        loyaltyId: skipIDs ? null : idType === "loyalty" ? selectedLoyaltyId.trim() : "",
        billtoID: skipIDs ? null : idType === "billto" ? billToId.trim() : "",
        ...(selectedTemplate?.template === 'redeemApproved' && {
          transactionNumber,
          pointsRedeemed,creditPoints
        }),
      };
      

      const result = await handleSendEmail(payload);

      if (result?.success) {
        dispatch({
          type: "SET_TOAST",
          payload: {
            type: "success",
            message: "Email sent successfully!",
          },
        });
        setSendModalOpen(false);
        resetModalFields();
      } else {
        dispatch({
          type: "SET_TOAST",
          payload: {
            type: "error",
            message: result?.message || "Failed to send email.",
          },
        });
      }
    } catch (error) {
      console.error("Send email error:", error);
      dispatch({
        type: "SET_TOAST",
        payload: {
          type: "error",
          message: "An error occurred while sending the email.",
        },
      });
    }
  };

  const resetModalFields = () => {
    setSelectedRecipientEmail("");
    setSelectedLoyaltyId("");
    setBillToId("");
    setSelectedTemplate(null);
    setIdType("loyalty");
  };

  const handleCancel = () => {
    resetModalFields();
    setSendModalOpen(false);
    setEditModalOpen(false);
  };

  const skipIDs = templatesWithoutIDs.includes(selectedTemplate?.template);
  const handleEditClick = (template) => {
    setSelectedTemplate(template);
    setEditSubject(template.subject || "");

    setTabValue(0);
    setEditModalOpen(true);
  };
  const handleSaveEdit = async () => {
    if (!selectedTemplate) return;
  
    try {
      if (editSubject !== selectedTemplate.subject) {
        const subjectRes = await updateSubject({
          template: selectedTemplate.template,
          editsubject: editSubject,
        });
  
        if (!subjectRes?.valid) {
          toast.error(subjectRes.message || "Failed to update subject");
          return;
        }
  
        toast.success("Subject updated successfully!");
        // Close modal and reset fields
        setEditModalOpen(false);
        setSelectedTemplate(null);
        setEditSubject("");
        setTabValue(0);
        fetchTemplates();
      }
    } catch (error) {
      console.error("Update template error:", error);
      toast.error("An error occurred while updating the template");
    }
  };
  

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={12}></Grid>
      </Grid>

      <Loader loading={state.loading} top="15%">
        <Grid className={classes.tableDownInResponsive}>
          <Grid item xs={12}>
            {res ? (
              <Table
              headings={["S.No", "Email Template", "Subject", "Description", "Notify",(state?.userInfo?.role_id === 10 ? ["Actions"] : [])]}
              data={
                data.length > 0 &&
                data.map((d, i) => [
                  (offset - 1) * limit + i + 1,
                  <div className={classes.wordBreakCell}>
                    {d?.template || "-"}
                  </div>,
                  d?.subject || "-",
                  d?.description || "-",
                  <Button
                    key={`send-btn-${i}`}
                    className={classes.historyBtn}
                    onClick={() => {
                      setSelectedTemplate(d);
                      setSendModalOpen(true);
                    }}
                    style={{ minWidth: "60px", padding: "4px 12px" }}
                  >
                    {t("Send")}
                  </Button>,
                  state?.userInfo?.role_id === 10 ? (
                    <Button
                      key={`edit-btn-${i}`}
                      className={classes.historyBtn}
                      color="primary"
                      variant="outlined"
                      onClick={() => handleEditClick(d)}
                      style={{ minWidth: "60px", padding: "4px 12px" }}
                    >
                      {t("Edit")}
                    </Button>
                  ) : null
                ])
              }
              offset={offset}
              count={Math.ceil(count / limit)}
              handlePagination={handlePagination}
            />            
              
            ) : (
              <Loader loading={true} top="15%" />
            )}
          </Grid>
        </Grid>
      </Loader>

      <Dialog open={sendModalOpen} onClose={handleCancel} maxWidth="sm" fullWidth>
        <DialogTitle
          disableTypography
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          <Typography variant="h6" style={{ fontWeight: "bold", flex: 1, textAlign: "center" }}>
            Send Email
          </Typography>
          <IconButton onClick={handleCancel} size="small" style={{ color: "red" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
              padding: "10px",
            }}
          >
            <Typography variant="subtitle1">
              Description: <b>{selectedTemplate?.description}</b>
            </Typography>
            <Typography variant="subtitle2">
              Subject: <b>{selectedTemplate?.subject}</b>
            </Typography>

            <TextField
              label="Recipient Email ID"
              fullWidth
              margin="normal"
              variant="outlined"
              value={selectedRecipientEmail}
              onChange={(e) => setSelectedRecipientEmail(e.target.value)}
              style={{ maxWidth: "400px" }}
            />

            {!skipIDs && (
              <>
                <TextField
                  select
                  label="Select ID Type"
                  value={idType}
                  onChange={(e) => setIdType(e.target.value)}
                  variant="outlined"
                  fullWidth
                  SelectProps={{ native: true }}
                  style={{ maxWidth: "400px" }}
                >
                  <option value="loyalty">Loyalty ID</option>
                  <option value="billto">BillTo ID</option>
                </TextField>

                {idType === "loyalty" ? (
                  <TextField
                    label="Loyalty ID"
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    value={selectedLoyaltyId}
                    onChange={(e) => setSelectedLoyaltyId(e.target.value)}
                    style={{ maxWidth: "400px" }}
                  />
                ) : (
                  <TextField
                    label="BillTo ID"
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    value={billToId}
                    onChange={(e) => setBillToId(e.target.value)}
                    style={{ maxWidth: "400px" }}
                  />
                )}
                {state?.userInfo?.role_id === 10 && selectedTemplate?.template === 'redeemApproved' && (
  <>
    <TextField
      label="Date of Transaction"
      fullWidth
      margin="normal"
      variant="outlined"
      value={transactionNumber}
      onChange={(e) => setTransactionNumber(e.target.value)}
      style={{ maxWidth: "400px" }}
    />

    <TextField
      label="Number of Points Redeemed"
      type="number"
  onWheel={(e) => e.target.blur()}
      fullWidth
      margin="normal"
      variant="outlined"
      value={pointsRedeemed}
      onChange={(e) => setPointsRedeemed(e.target.value)}
      style={{ maxWidth: "400px" }}
    />
    <TextField
      label="Credit Value of Redemption"
      type="number"
  onWheel={(e) => e.target.blur()}
      fullWidth
      margin="normal"
      variant="outlined"
      value={creditPoints}
      onChange={(e) => setCreditPoints(e.target.value)}
      style={{ maxWidth: "400px" }}
    />
  </>
)}

              </>
            )}
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCancel} color="default">
            Cancel
          </Button>
          <Button
            onClick={handleSendClick}
            color="primary"
            variant="contained"
            disabled={!selectedRecipientEmail}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Edit Modal */}
      <Dialog open={editModalOpen} onClose={handleCancel} maxWidth="md" fullWidth>
        <DialogTitle
          disableTypography
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          <Typography variant="h6" style={{ fontWeight: "bold", flex: 1, textAlign: "center" }}>
            Edit Subject
          </Typography>
          <IconButton onClick={handleCancel} size="small" style={{ color: "red" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Tabs
            value={tabValue}
            onChange={(e, newVal) => setTabValue(newVal)}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Subject" />
          </Tabs>

          {/* Subject tab */}
          {tabValue === 0 && (
            <TextField
              label="Subject"
              fullWidth
              margin="normal"
              variant="outlined"
              value={editSubject}
              onChange={(e) => setEditSubject(e.target.value)}
              inputProps={{ maxLength: 200 }}
              helperText={`${editSubject.length}/200 characters`}
            />
          )}

          </DialogContent>
          
        <DialogActions style={{ justifyContent: "flex-end", gap: "10px" }}>
          <Button onClick={handleCancel} color="default">
            Cancel
          </Button>
          <Button onClick={handleSaveEdit} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
}
